import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export function AppRouteScrollReset() {
  const { hash, pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (hash || navigationType === "POP") return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [hash, navigationType, pathname]);

  return null;
}
